import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent, AdobeAnalyticsService } from './../../cfet-core';

@Component({
    selector: 'app-cfet-nav-footer',
    templateUrl: './cfet-nav-footer.component.html',
    styleUrls: ['./cfet-nav-footer.component.scss'],
    standalone: false
})
export class CfetNavFooterComponent extends CfetBaseComponent implements OnInit {
  showDeviceAndService = true;
  showfirstnetlocalcontrol = true;
  httpHeaders: any;
  hideFooter = true;
  hideActivationFooter: boolean;
  isNumberSyncFlow: boolean;
  intellectual_property: string;
  trapFocusForCato: boolean;
  isAgentFacing = false;
  isFirstnetSiteMap = true;

  constructor(private adobeAnalyticsService: AdobeAnalyticsService) {
    super();
  }

  ngOnInit () {
    this.intellectual_property = this.cfetNavLables.footer_menu.intellectual_property.replace('{1}', new Date().getFullYear());
  }

  onFirstnetCentral () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.firstnet_central, this.cfetNavLinks.footer_links.firstnet_central);
  }

  onDevicesServices () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.devices_service, this.cfetNavLinks.footer_links.devices_services);
  }

  onAboutFirstnet () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.about_firstnet, this.cfetNavLinks.footer_links.about_firstnet);
  }

  onFirstnetSiteMap () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.firstnet_site_map, this.cfetNavLinks.footer_links.firstnet_site_map);
  }

  onPrivacyPolicy () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.privacy_policy, this.cfetNavLinks.footer_links.privacy_policy);
  }

  onTermsOfUse () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.terms_of_use, this.cfetNavLinks.footer_links.terms_of_use);
  }

  onContactUs () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.contact_us, this.cfetNavLinks.footer_links.contact_us);
  }

  onPersonalInformation () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.personal_information, this.cfetNavLinks.footer_links.personal_information);
  }

  onHealthNotice () {
    this.adobeLinkClick(this.cfetNavLables.footer_menu.health_notice, this.cfetNavLinks.footer_links.health_notice);
  }

  onIntellectualProperty () {
    window.location.href = this.cfetNavLinks.footer_links.intellectual_property;
    this.adobeLinkClick(this.intellectual_property, this.cfetNavLinks.footer_links.intellectual_property);
  }

  onIntellectualPropertyActivation () {
    window.location.href = this.cfetNavLinks.footer_links.intellectual_property_activation;
    this.adobeLinkClick(this.intellectual_property,
      this.cfetNavLinks.footer_links.intellectual_property_activation);
  }

  adobeLinkClick (linkName, destUrl) {
    const eventData = {
      eventAction: 'linkClick',
      eventCode: 'Link_Click',
      objData: {
        linkName: linkName,
        linkPosition: 'Footer',
        linkDestinationUrl: `${window.location.host}${destUrl}`
      }
    };
    this.adobeAnalyticsService.pushToDatalayerPushEvent(eventData.eventAction, eventData.eventCode, eventData.objData);
  }

}
